import React, { useMemo } from 'react';
import { FlowNode } from '../../Types/Types.ts';
import { useAppState } from '../../BikesAppState.tsx';

import './ChoiceStep.less';

type ChoiceStepProps = {
  node: FlowNode;
};

const ChoiceStep = ({ node }: ChoiceStepProps) => {
  const { answers, products, fitAssistantBikesData, selectOption } = useAppState();
  const cmsStep = fitAssistantBikesData?.Steps?.find((stepData) => stepData.Parameter === node.cmsParameter);
  const translations = fitAssistantBikesData?.Translations;

  const options = useMemo(() => {
    const computed = node.getOptions?.({ answers, products, translations: translations }) ?? [];
    if (computed.length > 0) {
      return computed;
    }
    if (!cmsStep?.ContentOptions?.length) {
      return computed;
    }
    return cmsStep.ContentOptions.map((option) => ({
      value: option.Title.trim().toLowerCase(),
      label: option.Title,
      description: option.Description,
    }));
  }, [answers, cmsStep?.ContentOptions, node, products]);

  return (
    <>
      <div className="choice-step">
        <div className="choice-step-content select mb-10">
          {cmsStep?.ImageUrl && (
            <div className="cms-image-wrapper d-flex justify-content-center w-100 mb-9">
              <img src={cmsStep.ImageUrl} alt={cmsStep.ImageAlt} />
            </div>
          )}
          {cmsStep?.Text && <div dangerouslySetInnerHTML={{ __html: cmsStep.Text }}></div>}
          {options.map((option, index) => (
            <div className="list-item" onClick={() => selectOption(option)} key={`${option.value}-${index}`}>
              <div className="list-item-text">
                <span className="header">{option.label}</span>
                {option.description && <p>{option.description}</p>}
                {<i className="le-icon-chevron rot-180"></i>}
              </div>
            </div>
          ))}
        </div>

        {cmsStep?.PDFUrl && (
          <a href={cmsStep?.PDFUrl} className="paragraph text-decoration-underline">
            {cmsStep?.PDFLinkText}
          </a>
        )}
      </div>
    </>
  );
};

export default ChoiceStep;
